import { IconFont, Input, Select } from '@byecode/ui'
import styled from 'styled-components'

export const BlockSettingContainer = styled.div`
    // 修复按钮组拖拽按钮到dom外时被隐藏
    /* overflow: hidden; */
`

export const BlockSettingIcon = styled(IconFont)`
    font-size: var(--font-size-base);
`

export const BlockSettingContentContainer = styled.div`
    font-size: 14px;
`

export const BlockSettingsInput: typeof Input = styled(Input)<{ width?: number }>`
    flex: 1;
    width: ${({ width }) => (width ? `${width}px` : '100%')};
    flex: none;
`

export const BlockSettingsSelect: typeof Select = styled(Select)``
